import { missionDetailText } from './missionDetailTexts';

export const MISSION_DETAIL_TAB = {
  MISSION: 'mission',
  REQUIREMENTS: 'requirements',
  TASKS: 'tasks',
  RISK: 'risk',
};

/** The sub-tabs of the mission detail, in their PillTabs shape. */
export const missionDetailTabList = () =>
  Object.values(MISSION_DETAIL_TAB).map((id) => ({
    id,
    label: missionDetailText(`tabs.${id}`),
  }));
